import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { client } from '../api/client';

export const CheckoutSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Verifying payment...');

  useEffect(() => {
    const verifyPayment = async () => {
      const sessionId = searchParams.get('session_id');
      const cardId = searchParams.get('card_id');

      if (!sessionId || !cardId) {
        setStatus('error');
        setMessage('Invalid payment session.');
        return;
      }

      try {
        const { error } = await supabase.functions.invoke('market-ops', {
          body: { action: 'verify', sessionId, cardId }
        });

        if (!error) {
          setStatus('success');
          setMessage('Payment successful! Card added to your collection.');
          setTimeout(() => navigate('/collection'), 3000);
        } else {
          setStatus('error');
          setMessage(error.message || 'Payment verification failed.');
        }
      } catch (e) {
        setStatus('error');
        setMessage('Network error during verification.');
      }
    };

    verifyPayment();
  }, []);

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center p-4">
      <div className="glass p-8 rounded-3xl max-w-md w-full text-center">
        {status === 'loading' && (
          <>
            <Loader2 className="w-16 h-16 text-electric-500 animate-spin mx-auto mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">Processing...</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">Success!</h2>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">Error</h2>
          </>
        )}
        <p className="text-slate-400">{message}</p>

        {status !== 'loading' && (
          <button
            onClick={() => navigate('/market')}
            className="mt-6 px-6 py-2 bg-white/10 rounded-xl text-white hover:bg-white/20 transition-colors"
          >
            Back to Market
          </button>
        )}
      </div>
    </div>
  );
};
